/* TEUF Studio theme — header state, mobile menu and reveal animations for store pages */
(function () {
  'use strict';

  function init() {
    var header = document.querySelector('[data-teuf-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 30); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var mobile = document.querySelector('[data-teuf-mobile]');
    var openBtn = document.querySelector('[data-teuf-menu]');
    var closeBtn = document.querySelector('[data-teuf-menu-close]');
    function setMenu(open) {
      if (!mobile) return;
      mobile.hidden = !open;
      if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (openBtn) openBtn.addEventListener('click', function () { setMenu(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });

    // reveal elements on store pages (the homepage section handles its own)
    var els = Array.prototype.filter.call(document.querySelectorAll('.teuf-theme .tf-reveal'), function (el) {
      return !el.closest('.tf-home');
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.1 });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
